export default __webpack_public_path__ + "static/media/100_39330.256195d8.jpg";